import React from "react"

const ArrowSelect = () => (
  <svg
    width="17"
    height="11"
    viewBox="0 0 17 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M1 1L8.5 9L16 1" stroke="black" strokeWidth="1.5" />
  </svg>
)

export { ArrowSelect }
